import './Auth.css';
import {Link, useNavigate} from "react-router-dom";

const Auth = () => {
    const navigate = useNavigate();

    const connect = () => {
        let auth = {

        }
        sessionStorage.setItem('auth', JSON.stringify(auth));
        navigate("/");
    }

    return (
        <>
            <Link to={"/"} className={"header-link"}>
                <button className={"btn home-link"}> {"<<"} Page d'accueil</button>
            </Link>
            <div className={"login-container"}>
                <div className={"login-img"}>
                    <img src={"services/plateforme-de-marche-agricole-en-ligne.webp"} alt={"Agri-Tech Solution Madagascar"} />
                </div>
                <div className={"login-form"}>
                    <h1 className={"auth-title"}>Authentification</h1>
                    <div>
                        <label className={"auth-label"}>Numéro</label>
                        <div>
                            <input type={"text"} className={"auth-input  form-control"}/>
                        </div>
                    </div>
                    <div>
                        <label className={"auth-label"}>Mot de passe</label>
                        <div>
                            <input type={"password"} className={"auth-input form-control"}/>
                        </div>
                    </div>
                    <button className={"auth-button btn"} onClick={connect}>Se connecter</button>
                </div>
            </div>
        </>
    )
}

export default Auth;